// extracted by mini-css-extract-plugin
export default {"video":"VideoPreview_video__Kiu7o"};